export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["DRAFT"] = "DRAFT";
    InvoiceStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    InvoiceStatus["APPROVED"] = "APPROVED";
    InvoiceStatus["SENT_TO_CLIENT"] = "SENT_TO_CLIENT";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["CANCELLED"] = "CANCELLED";
})(InvoiceStatus || (InvoiceStatus = {}));
//# sourceMappingURL=invoice.js.map